import React, { useCallback, useMemo } from 'react';
import Link from 'next/link';
import * as ST from './styled';
import data from '~/src/components/Header/Profile/links.json';
import { PRODUCTS } from '~/src/constants';
import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import { CATEGORIES, EVENTS } from '~/src/constants/analytics';

interface IProps {
    productsInfo: {
        productId: number;
    }[];
    logout: () => void;
}

interface ILinksData {
    text: string;
    link?: string;
    action?: string;
    onClick: (action?: string) => void;
    dataTest?: string;
}

export const RightCollapsedMenu: React.FC<IProps> = ({ productsInfo, logout }) => {

    const sendEvent = useCallback((action) => {
        if (action) {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: CATEGORIES.header,
                action: action,
                label: 'menu_new',
            });
        }
    }, []);

    const exit = useCallback(() => {
        if (logout) {
            sendEvent('clicked btn exit');
            logout();
        }
    }, [logout]);

    const links = useMemo<ILinksData[]>(() => {
        const result: ILinksData[] = [...data]
            .map(item => {
                return {
                    ...item,
                    onClick: () => sendEvent(item.action)
                };
            })
            .filter(link =>
                link.link === '/settings' &&
                productsInfo?.find(productInfo => productInfo.productId === PRODUCTS.internet) ||
                link.link !== '/settings');

        result.push({
            text: 'Выход',
            onClick: exit,
            dataTest: 'lk-logout',
        });
        return result;
    }, [productsInfo]);

    return (
        <ST.RightCollapsedMenu>
            {links.map(item => (
                item.link
                    ? <Link
                        key={item.text}
                        href={item.link}
                        prefetch={false}
                    >
                        <a onClick={() => item.onClick(item.action)}>
                            {item.text}
                        </a>
                    </Link>
                    : <span
                        key={item.text}
                        onClick={() => item.onClick(item.action)}
                        data-test={item.dataTest}
                    >
                        {item.text}
                    </span>
            ))}
        </ST.RightCollapsedMenu>
    );
};

export default RightCollapsedMenu;
